import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface ToastMessage {
  summary?: string;
  detail?: string;
  data?: unknown;
}

@Component({
  standalone: true,
  imports: [TranslateModule],
  selector: 'app-toast-message',
  host: { style: 'display:block;width:100%' },
  template: `
    <div class="flex flex-col gap-1 w-full">
      <span class="font-semibold block">{{ message().summary }}</span>
      @if (message().detail) {
        <div class="text-sm">{{ message().detail }}</div>
      }
      @if (message().data) {
        <details class="mt-2">
          <summary class="text-xs cursor-pointer select-none opacity-75 hover:opacity-100">
            {{ 'common.notifications.error_details_label' | translate }}
          </summary>
          <pre
            class="text-xs mt-1 overflow-auto max-h-48 whitespace-pre-wrap break-all font-mono opacity-75"
            >{{ message().data }}</pre
          >
        </details>
      }
    </div>
  `,
})
export class ToastMessageComponent {
  readonly message = input.required<ToastMessage>();
}
